import { ExpertFilterDropdown } from "./ExpertFilterDropdown";

interface Expert {
  data: {
    name: string;
    family_name: string;
  };
  email: string;
}

interface AdminFiltersProps {
  nutritionists: Expert[];
  physicians: Expert[];
  selectedNutritionist: string | null;
  selectedPhysician: string | null;
  onNutritionistSelect: (name: string, email: string) => void;
  onPhysicianSelect: (name: string, email: string) => void;
  onResetNutritionists: () => void;
  onResetPhysicians: () => void;
  totalPatients: number;
  compact?: boolean;
}

export const AdminFilters: React.FC<AdminFiltersProps> = ({
  nutritionists,
  physicians,
  selectedNutritionist,
  selectedPhysician,
  onNutritionistSelect,
  onPhysicianSelect,
  onResetNutritionists,
  onResetPhysicians,
  totalPatients,
  compact = false,
}) => {
  if (compact) {
    return (
      <div className="flex flex-col space-y-2">
        <div className="font-bold text-[16px] leading-[20px]">
          Filtri Admin
        </div>
        <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-3 sm:space-y-0 sm:space-x-3">
          <ExpertFilterDropdown
            experts={nutritionists}
            selectedExpert={selectedNutritionist}
            placeholder="Nutrizionista"
            onExpertSelect={onNutritionistSelect}
            onReset={onResetNutritionists}
            resetText="Reset Nutrizionisti"
            compact={true}
          />
          <ExpertFilterDropdown
            experts={physicians}
            selectedExpert={selectedPhysician}
            placeholder="Medico"
            onExpertSelect={onPhysicianSelect}
            onReset={onResetPhysicians}
            resetText="Reset Medici"
            compact={true}
          />
          <div className="text-sm text-gray-600 whitespace-nowrap self-start sm:self-center">
            Totali: {totalPatients}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full shadow-platform flex items-center justify-between px-[20px] py-[30px]">
      <div className="flex space-x-4">
        <ExpertFilterDropdown
          experts={nutritionists}
          selectedExpert={selectedNutritionist}
          placeholder="Seleziona nutrizionista"
          onExpertSelect={onNutritionistSelect}
          onReset={onResetNutritionists}
          resetText="Reset Nutrizionisti"
        />
        <ExpertFilterDropdown
          experts={physicians}
          selectedExpert={selectedPhysician}
          placeholder="Seleziona medico"
          onExpertSelect={onPhysicianSelect}
          onReset={onResetPhysicians}
          resetText="Reset Medici"
        />
      </div>
      <div>
        Totali: {totalPatients}
      </div>
    </div>
  );
}; 